import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center px-6 pt-40 pb-24">
            <div className="text-center">
                <div className="font-display font-black text-9xl text-[#E87722] leading-none">404</div>
                <h1 className="mt-6 font-display font-black uppercase text-[var(--fg)] text-4xl md:text-5xl">Off the map.</h1>
                <p className="mt-4 font-body text-[var(--fg-muted)] max-w-md mx-auto">This road doesn't exist yet. Head back to the guide.</p>
                <Link
                    to="/"
                    data-testid="not-found-home-link"
                    className="mt-10 inline-block bg-[#E87722] hover:bg-[#F28C38] text-black px-8 py-4 font-display font-bold uppercase tracking-[0.2em] text-sm transition-all"
                >
                    Back to Home
                </Link>
            </div>
        </div>
    );
}
